<!-- 智慧停车用户绑定车牌及变更上报接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/comUpwardStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "carObj":
                    {
                        "bindingDate": "20170929160020",
                        "carNo": "津M95621",
                        "type": 0,
                        "status": 0,
                        "default": 0,
                        "authDate": "20170929160020"
                    },
                "cmd": "reportAuthUserCarInfo",
                "phone": "18054103169",
                "userId": 127,
                "lockKey": "2420e3efbf6124c7185365b79c75c0f5be61a049"
            },
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "智慧停车开放平台主动上报智慧停车用户绑定车牌及变更信息到第三方接入系统",
                urlPattern:this.commonUrls.third+"reportAuthUserCarInfo",
                precondition: "无",
                fitSystem: "VEMS传统停车场,云停车场",
                pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
                frequency:"实时触发",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'phone', info2: '是', info3: 'String', info4: '用户电话号码' },
                        { info1: 'userId', info2: '是', info3: 'Long', info4: '智慧停车用户id' },
                        { info1: 'carObj', info2: '是', info3: 'JSONObject', info4: '车牌列表' },
                        { info1: 'lockKey', info2: '是', info3: 'String', info4: '数据唯一标识' },
                        ]
                },{
                    titleName: 'carObj',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'carNo', info2: '是', info3: 'String', info4: '车牌号码' },
                        { info1: 'type', info2: '是', info3: 'Integer', info4: '类型。0 新绑定 1变更 2未变动' },
                        { info1: 'bindingDate', info2: '是', info3: 'String', info4: '绑定、解绑时间, yyyy-MM-dd HH:mm:ss' },
                        { info1: 'status', info2: '是', info3: 'Integer', info4: '状态，0:BINDING,1:DELETED,2:AUTH,3:AUTH_BY_OTHER' },
                        { info1: 'default', info2: '是', info3: 'Integer', info4: '是否为默认车牌号码。0否 1是缺省车牌' },
                        { info1: 'authDate', info2: '是', info3: 'String', info4: '认证时间, yyyyMMddHHmmss' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [
                        ]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/urbanOperation/ydtUser/reportAuthUserCarInfo.vue